import { useState, useEffect } from "react";

export function useBuildVersion() {
  const [buildVersion, setBuildVersion] = useState<string>("-");

  useEffect(() => {
    // Fetch build version from public folder
    fetch("/buildversion.txt")
      .then(async (response) => {
        // Check if response is OK
        if (!response.ok) {
          return null;
        }

        // Check content-type to ensure it's a text file, not HTML
        const contentType = response.headers.get("content-type") || "";
        const isTextFile =
          contentType.includes("text/plain") ||
          contentType.includes("text/") ||
          contentType === "";

        if (!isTextFile) {
          return null;
        }

        const text = await response.text();
        const trimmed = text.trim();

        // Validate that it's not HTML (common when file doesn't exist and Vite returns index.html)
        // Check for common HTML patterns
        const isHtml =
          trimmed.startsWith("<!") ||
          trimmed.includes("<html") ||
          trimmed.includes("<!doctype") ||
          trimmed.includes("<script") ||
          trimmed.includes("<meta") ||
          trimmed.length > 1000; // HTML files are usually longer

        if (trimmed && !isHtml) {
          return trimmed;
        }

        return null;
      })
      .then((version) => {
        setBuildVersion(version || "-");
      })
      .catch(() => {
        setBuildVersion("-");
      });
  }, []);

  return buildVersion;
}
